export const fontFamily = [
    'Hiragino Kaku Gothic ProN',
    'ヒラギノ角ゴ ProN W3',
    'Hiragino Sans',
    'ヒラギノ角ゴシック',
    'メイリオ',
    'ＭＳ Ｐゴシック',
    'Open Sans',
    'system-ui',
    'sans-serif',
].map(f => f.match(/^[a-zA-Z-]+$/) ? f : `'${f}'`).join(', ');
